import { AutogenLayoutCommissionsManagement } from "./autogen/AutogenLayoutCommissionsManagement";
import {
    ChangeEvent, DataSourceAction, DataSourceExecutionEvent, DataSourceMode, DataSourceModeChangeEvent,
    LookupModelSearchEvent, TableRow, TableRowDisplayEvent, Textbox, ValidationResult
} from "@mcleod/components";
import { FieldUpdateEvent } from "@mcleod/core";
import { ModelCommission } from "../../commissions/src/models/ModelCommission";
import { CommonDialogs } from "@mcleod/common";

export class CommissionsManagement extends AutogenLayoutCommissionsManagement {
    onLoad(): void | Promise<void> {
        this.mainDataSource.addAfterModeChangeListener((event: DataSourceModeChangeEvent) => {
            if (event.newMode === DataSourceMode.ADD || event.newMode === DataSourceMode.UPDATE) {
                this.activeRow.addAfterFieldUpdateListener((event: FieldUpdateEvent) => {
                    if (event.fieldName === "off_payee.enable_commissions_pay") {
                        this.setUserIdRequired();
                    }
                });
            }
        });
        this.mainDataSource.addAfterExecutionListener((event: DataSourceExecutionEvent) => {
            if (event.getAction() === DataSourceAction.SEARCH) {
                this.setUserIdRequired();
            }
        });
        this.tableRoleRate.addRowDisplayListener((event: TableRowDisplayEvent) => {
            const tableRow: TableRow = event.getTableRow();
            this.addRowValidationListeners(tableRow);
        });
        this.textboxOffPayeeUserId.addBeforeLookupModelSearchListener((event: LookupModelSearchEvent) => {
            event.filter.web_user_type = "U ||E";
        });
        this.switchEnableCommissionsPayments.addChangeListener(async (event: ChangeEvent) => {
            if (this.mainDataSource.mode !== DataSourceMode.UPDATE) return;

        });
        this.mainDataSource.doBeforeDataSourcePost = async () => {
            if (this.activeRow.getChangedData()?.enable_commissions_pay && !this.activeRow.getBoolean("off_payee.enable_commissions_pay", false)) {
                const commissions = await new ModelCommission().search({ payee_id: this.activeRow.get("id") });
                const notVoidedRecords = commissions.modelRows?.filter(row => row.get("ready_to_pay_flag") != "V");
                if (notVoidedRecords) {
                    const isYes = await CommonDialogs.showYesNo("Commissions payments have been disabled, " +
                        "and unpaid commissions records will no longer be created for this payee. " +
                        "Do you want to void the existing unpaid commissions records for this payee?", "Void Commissions");
                    if (isYes) {
                        this.activeRow.set("off_payee.commission_status", null);
                        notVoidedRecords.forEach(record => {
                            record.set("ready_to_pay_flag", "V");
                            record.post();
                        });
                    }
                }
            }
            return true;
        }
    }

    setUserIdRequired(): void {
        this.textboxOffPayeeUserId.required = this.activeRow.getBoolean("off_payee.enable_commissions_pay", false);
    }

    addRowValidationListeners(tableRow: TableRow) {
        const textboxRoleId = tableRow.findComponentById("textboxRoleId") as Textbox;
        if (textboxRoleId) {
            textboxRoleId.addlValidationCallback = (_value: string, mode: DataSourceMode): ValidationResult => {
                if (mode === DataSourceMode.SEARCH) {
                    return null;
                }
                const result: ValidationResult = {
                    component: textboxRoleId,
                    isValid: true
                }
                const effectiveDate: Date = tableRow.data.getDate("effective_date");
                const expirationDate: Date = tableRow.data.getDate("expiration_date");
                if (effectiveDate == null) {
                    return result;
                }
                // check if any other rows have conflicting date ranges, make sure to check if expiration date is null
                const conflictingRecord = this.tableRoleRate.rows.filter((row: TableRow) => {
                    const rowEffectiveDate: Date = row.data.getDate("effective_date");
                    const rowExpirationDate: Date = row.data.getDate("expiration_date");
                    const rowRoleId: string = row.data.get("role_id");
                    return row != tableRow && rowRoleId === tableRow.data.get("role_id") &&
                        ((rowExpirationDate != null && rowExpirationDate >= effectiveDate) || (rowExpirationDate == null && rowEffectiveDate <= effectiveDate))
                });
                if (conflictingRecord.length > 0) {
                    result.isValid = false;
                    result.validationMessage = `Row cannot be saved because role ${tableRow.data.get("role_id")} already exists within this effective date range`;
                }
                return result;
            };
        }
    }

    /** This is an event handler for the beforeLookupModelSearch event of textboxOffPayeeEarningCode. */
    textboxOffPayeeEarningCodeBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter.code_type = "E";
    }
}
